/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaRtSystemTemplateContainerEntryDto } from './QaRtSystemTemplateContainerEntryDto';
import {
    QaRtSystemTemplateContainerEntryDtoFromJSON,
    QaRtSystemTemplateContainerEntryDtoFromJSONTyped,
    QaRtSystemTemplateContainerEntryDtoToJSON,
} from './QaRtSystemTemplateContainerEntryDto';

/**
 * 
 * @export
 * @interface QaRtSystemTemplateContainerDto
 */
export interface QaRtSystemTemplateContainerDto {
    /**
     * 
     * @type {string}
     * @memberof QaRtSystemTemplateContainerDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QaRtSystemTemplateContainerDto
     */
    isMultiSelect?: boolean;
    /**
     * 
     * @type {Array<QaRtSystemTemplateContainerEntryDto>}
     * @memberof QaRtSystemTemplateContainerDto
     */
    entries?: Array<QaRtSystemTemplateContainerEntryDto> | null;
    /**
     * 
     * @type {string}
     * @memberof QaRtSystemTemplateContainerDto
     */
    $type?: QaRtSystemTemplateContainerDtoTypeEnum;
}


/**
 * @export
 */
export const QaRtSystemTemplateContainerDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoQaRtSystemTemplateContainerDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.QaRtSystemTemplateContainerDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type QaRtSystemTemplateContainerDtoTypeEnum = typeof QaRtSystemTemplateContainerDtoTypeEnum[keyof typeof QaRtSystemTemplateContainerDtoTypeEnum];


/**
 * Check if a given object implements the QaRtSystemTemplateContainerDto interface.
 */
export function instanceOfQaRtSystemTemplateContainerDto(value?: unknown): value is QaRtSystemTemplateContainerDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(QaRtSystemTemplateContainerDtoTypeEnum)[0];
}

export function QaRtSystemTemplateContainerDtoFromJSON(json: any): QaRtSystemTemplateContainerDto {
    return QaRtSystemTemplateContainerDtoFromJSONTyped(json, false);
}

export function QaRtSystemTemplateContainerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaRtSystemTemplateContainerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isMultiSelect': !exists(json, 'isMultiSelect') ? undefined : json['isMultiSelect'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'] === null ? null : (json['entries'] as Array<any>).map(QaRtSystemTemplateContainerEntryDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function QaRtSystemTemplateContainerDtoToJSON(value?: QaRtSystemTemplateContainerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'isMultiSelect': value.isMultiSelect,
        'entries': value.entries === undefined ? undefined : (value.entries === null ? null : (value.entries as Array<any>).map(QaRtSystemTemplateContainerEntryDtoToJSON)),
        '$type': value.$type,
    });
}

